import React, { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchManagers } from "../util/fetchUserUtil";

export const ManagersTable = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchManagers();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "New Manager",
      action: "create_manager",
    },
  ];

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"telecom_managers"}
        tableType={"telecom_managers"}
        tableName={"Managers"}
        needGlobalFilter={false}
        needColumnFilter={false}
        needPagination={false}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
        isExtendingReusableColumns={true}
      />
    </div>
  );
};

export default ManagersTable;
